import { render } from "./MoveOrders.vue?vue&type=template&id=2b9b9419&scoped=true"
import script from "./MoveOrders.vue?vue&type=script&lang=js"
export * from "./MoveOrders.vue?vue&type=script&lang=js"

import "./MoveOrders.vue?vue&type=style&index=0&id=2b9b9419&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9b9419"]])

export default __exports__